<template>
  <div>
    <page-header header="Notify Users">
      <button
        class="bg-tertiary text-white rounded-lg p-4 uppercase text-sm font-medium align-bottom"
        @click="save"
        :disabled="isSaving"
        :class="{ 'opacity-50': isSaving }"
      >
        <i v-if="isSaving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <i v-else class="far fa-save fa-fw fa-lg" />
        Save
      </button>
    </page-header>

    <div class="mt-16 p-6 bg-white rounded-lg">
      <div class="flex flex-wrap items-end -mx-4">
        <div class="px-4">
          <page-icon-picker
            :canPickColor="false"
            :icon="notification.icon"
            @change="iconSelected"
          />
        </div>
        <div class="px-4 w-full md:w-1/2">
          <input v-model="notification.subject" type="text" name="subject" id="notification-subject" placeholder="Subject" class="input w-full">
        </div>
      </div>
      <div class="mt-6 flex flex-wrap -mx-4">
        <div class="px-4 w-full">
          <textarea v-model="notification.description" name="description" id="notification-description" rows="3" placeholder="Description" class="input w-full"></textarea>
        </div>
      </div>
      <div class="mt-6 flex flex-wrap -mx-4">
        <div class="px-4 w-full md:w-1/2">
          <input v-model="notification.action" type="text" name="action" id="notification-action" placeholder="Action" class="input w-full">
        </div>
        <div class="px-4 w-full md:w-1/2 mt-6 md:mt-0">
          <input v-model="notification.link" type="text" name="link" id="notification-link" placeholder="https://..." class="input w-full">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import IconPicker from '@/components/IconPicker'
import PageIconPicker from '@/components/cms/PageIconPicker'
import { mapActions } from 'vuex'

export default {
  components: { IconPicker, PageIconPicker },

  data () {
    return {
      notification: {
        icon: 'information'
      },
      isSaving: false,
      errorBag: new ErrorBag()
    }
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    iconSelected (data) {
      this.notification.icon = data.icon
    },

    save () {
      this.isSaving = true
      this.errorBag.clear()

      api
        .post('notification', this.notification)
        .then(response => {
          this.isSaving = false
          this.$router.replace('/admin')
        })
        .catch(({ response }) => {
          this.isSaving = false
          this.errorBag.store(response.data)

          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-bell',
            title: 'Unable to create notification',
            info: response.data.message
          })
        })
    }
  }
}
</script>
